<ng-container *transloco="let _t">

<div class="actors" 
	cdkDropList
	[id]="id"
    [cdkDropListData]="users"
    [cdkDropListConnectedTo]="connectedLists"
    (cdkDropListDropped)="dropActor($event)">

	<button mat-mini-fab *ngIf="!showAddButton"
		class="emptyplace"
		[title]="_t('rm-team-title-0')"
		>
		<mat-icon>people</mat-icon>
	</button>

	<span *ngFor="let user of users; let u=index;"
		cdkDrag
		class="actor" 
		[title]="user.name+' (Double-click pour supprimer)'"
		[ngStyle]="{'background-color': getUserColor(user.name)}"
		(dblclick)="users.splice(u,1);"
	>{{user.initials}}</span>

	<button mat-mini-fab color="disabled" *ngIf="showAddButton"
			(click)="addUser()">
		<mat-icon>add</mat-icon>
	</button>
</div>

</ng-container>